import { EyeInvisibleOutlined } from "@ant-design/icons";
import React from "react";
import { $t } from "~/i18n.js";
import { deserializePhone } from "../../lib/localize.js";

export const DIAL_CODES = { NL: "31", BE: "32", DE: "49", FR: "33", GB: "44", AT: "43", CH: "41" };

export const toE164 = (number, country) => {
  if (!number || number === -1) return null;
  const s = number.toString().replace(/\s/g, "");
  if (s.startsWith("+")) return s;
  if (s.startsWith("00")) return "+" + s.slice(2);
  if (s.startsWith("0") && DIAL_CODES[country]) return `+${DIAL_CODES[country]}${s.slice(1)}`;
  return null;
};

export const downloadVCard = (pilot, number, clubName) => {
  const lines = ["BEGIN:VCARD", "VERSION:3.0"];
  if (pilot?.name) lines.push(`FN:${pilot.name}`);
  if (pilot?.last_name || pilot?.first_name) {
    lines.push(`N:${pilot?.last_name || ""};${pilot?.first_name || ""};;;`);
  }
  if (clubName) lines.push(`ORG:${clubName}`);
  if (number) lines.push(`TEL;TYPE=CELL:${number}`);
  if (pilot?.gegevens?.email) lines.push(`EMAIL;TYPE=INTERNET:${pilot.gegevens.email}`);
  const g = pilot?.gegevens;
  if (g?.address1 || g?.city || g?.zipcode) {
    const street = [g.address1, g.address2].filter(Boolean).join(" ");
    lines.push(`ADR;TYPE=HOME:;;${street};${g.city || ""};; ${g.zipcode || ""};${g.country || ""}`);
  }
  lines.push("END:VCARD");
  const blob = new Blob([lines.join("\r\n")], { type: "text/vcard;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = `${pilot?.name || "contact"}.vcf`;
  a.click();
  URL.revokeObjectURL(url);
};

export const Phone = ({ number, private_mode = false }) => {
  return (
    <div className="row">
      {private_mode && <EyeInvisibleOutlined style={{ margin: "1px 2px 0 0" }} />}
      <p style={{ marginLeft: private_mode ? 6 : 0, marginRight: 18 }}>
        {number ? deserializePhone(number) : $t("onbekend")}
      </p>
    </div>
  );
};
